import TerminationLetter from "../../../../components/company/workforce/termination/TerminationLetter";

export default function TerminationLetterPage(){
    return <TerminationLetter/>
}